module.exports = __webpack_public_path__ + "static/media/icons.3c1430ca.ttf";